import { render } from "./theme14.vue?vue&type=template&id=012bb25a&scoped=true"
import script from "./theme14.vue?vue&type=script&lang=js"
export * from "./theme14.vue?vue&type=script&lang=js"

import "./theme14.vue?vue&type=style&index=0&id=012bb25a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-012bb25a"

export default script